import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
), {
  shouldForwardProp: (prop) => prop !== 'colorvariant',
})(({ theme, colorvariant = 'lock' }) => {
  
  const isStandard = colorvariant === 'standard';
  
  return {
    width: 42,
    height: 26,
    padding: 0,
    display: 'flex',
    '&:active .MuiSwitch-thumb': {
      width: 22,
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: isStandard ? '#22C55E' : '#EF4444', // Vert pour activé, Rouge pour désactivé
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': { 
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: '#E9E9EA',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: '#E3E7EF',
        opacity: 1,
      },
    
    },
    '& .MuiSwitch-thumb': { 
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
      width: 22,
      height: 22,
      borderRadius: 11,
      backgroundColor: '#fff', // Force le fond du pouce en blanc
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: isStandard ? '#E9E9EA' : '#22C55E',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  };
});

export default IOSSwitch;